module.exports = __webpack_public_path__ + "img/63284d0.png";